import { applyUrlHostRewrite } from '@/utils/http'
import axios, { CreateAxiosDefaults } from 'axios'

class AxiosHttpFactory {
    createMultiClient = (config?: CreateAxiosDefaults) => {
        const axiosInstance = axios.create(config)

        if (!process.env.EXPO_PUBLIC_LOCAL_SERVER_MULTI_URL) {
            return axiosInstance
        }

        const localServerURL = process.env.EXPO_PUBLIC_LOCAL_SERVER_MULTI_URL
        axiosInstance.interceptors.request.use((config) =>
            applyUrlHostRewrite(config, localServerURL, 'X-Adaptee-Licence-Host')
        )

        return axiosInstance
    }
}

export default new AxiosHttpFactory()
